import React from 'react';
import './tariff.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import {
  Button, Col, Container, Row,
} from '../../../components/base/BootstrapComponents';
import { getTariffData } from '../reducer';
import notificationDecorator from '../../Notifications/notificationDecorator';
import { responseLogWithNotification } from '../../../utils/utils';
import { createCalendarDate, editCalendarDate } from '../actions';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import Loader from '../../../components/base/Loader/Loader';
import CalendarDateDTO from '../../../dto/CalendarDateDTO';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import DatePicker from '../../../components/fields/DatePicker/DatePicker';

export default function CalendarDateForm(props) {
  const {
    handleClose = () => {}, handleEdit = () => {}, handleSaved = handleClose, hasView = false,
  } = props;
  const dispatch = useDispatch();
  const {
    currentCalendarDate,
    loadingIntervalList,
  } = useSelector(getTariffData);
  const { control, getValues } = useForm({
    defaultValues: currentCalendarDate?.id ? currentCalendarDate : { lpns: [] },
  });

  const handleSave = () => {
    const isUpdate = currentCalendarDate?.id;
    const action = isUpdate ? editCalendarDate : createCalendarDate;
    const data = getValues();
    dispatch(action(data))
      .then(() => {
        handleSaved();
        notificationDecorator({
          title: isUpdate ? 'Редактирование дня' : 'Создание дня',
          message: isUpdate ? 'Редактирование дня прошло успешно' : 'Создание дня прошло успешно',
        });
      })
      .catch(responseLogWithNotification);
  };

  const tariffDTO = new CalendarDateDTO();
  const attributes = tariffDTO.getAttributesByName();

  const timeUnitOptions = [
    { nameId: 'calendar.date.type.workday', value: 'workday' },
    { nameId: 'calendar.date.type.holiday', value: 'holiday' },
  ];

  return (
    <div className="page-container tariff-form">
      <Loader loading={loadingIntervalList} />
      <div className="inputs-box">
        <PageHeader header={currentCalendarDate?.id ? 'Редактирование дня' : 'Создание дня'} />
      </div>
      <div className="plp-table g-0">
        <div className="frame py-3 d-flex flex-column px-3">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <div className="h4">
              Данные дня
            </div>
          </div>
          <Row className="h-100">
            <Col columns={6}>
              <Row>
                <Col columns={6}>
                  <FieldDTO
                    control={control}
                    type="text"
                    className="mb-2"
                    dtoObject={attributes.date}
                    addPlaceholder
                    component={DatePicker}
                    disabled={hasView}
                    withLabel
                    changeFormat="YYYY-MM-DD"
                    // onChangeToIso

                  />
                </Col>
                <Col columns={6}>
                  <FieldDTO
                    control={control}
                    type="text"
                    className="mb-2"
                    dtoObject={attributes.type}
                    addPlaceholder
                    component={CustomSelectInput}
                    disabled={hasView}
                    options={timeUnitOptions}
                    withLabel
                  />
                </Col>
              </Row>
              <FieldDTO
                control={control}
                type="text"
                className="mb-2"
                dtoObject={attributes.description}
                addPlaceholder
                component={TextInputWithLabel}
                disabled={hasView}
                textarea
              />
              <div className="text-center justify-content-center p-3">
                {!hasView
                  ? <Button className="me-3 px-3" onClick={handleSave}>Сохранить</Button>
                  : <Button className="me-3 px-3" onClick={handleEdit(currentCalendarDate)}>Редактировать</Button>}

                <Button variant="secondary" className="px-3" onClick={handleClose}>Закрыть</Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
